<template>
  <div class="digtital-container">
    <div class="banner">
      <VerticalBanner
        height="640px"
        :lists="lists"
        :indicatorPosition="'none'"
        :isShowMore="true"
      />
    </div>
    <div class="content-01">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        {{ content01.title }}
      </div>
      <div
        class="content text-wrap"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        {{ content01.content }}
        <!-- <p></p> -->
        <!-- <p v-for="item in content01.content" :key="item">· {{ item }}</p> -->
      </div>
      <div
        class="content-banner"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <ul class="product-lines">
          <li
            v-for="(line, index) in content01.productLines"
            :key="index"
            class="product-card"
            :class="{ selected: index === content01.selectedIndex }"
            @click="openUrl(line.link)"
            @mouseenter="pauseCarousel(index)"
            @mouseleave="startCarousel"
          >
            <span
              class="card-background"
              :style="{ backgroundImage: 'url(' + line.imageMask + ')' }"
            ></span>
            <div class="card-content">
              <img :src="line.image" alt="" class="card-img" />
              <div class="softwareName">{{ line.softwareName }}</div>
              <h3 class="title">{{ line.title }}</h3>
              <p class="products" v-if="line.products.length > 0">
                {{ line.products.join(" | ") }}
              </p>
              <template v-if="line.subTitles.length > 0">
                <p
                  class="products text-wrap"
                  v-for="(item, index) in line.subTitles"
                  :key="index"
                >
                  {{ item }}
                </p>
              </template>
            </div>
            <button class="know-more-btn">Learn More ></button>
            <img :src="line.icon" alt="" class="card-icon-notext" />
          </li>
        </ul>
      </div>
    </div>
    <div
      class="content-02"
      v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
    >
      <div class="title">{{ content02.title }}</div>
      <el-tabs v-model="content02.activeName">
        <el-tab-pane
          :label="item.title"
          :name="item.id"
          v-for="item in content02.content"
          :key="item.id"
        >
          <div class="sub-main">
            <div
              class="sub-box"
              v-scroll-animate="{ animation: 'bounceInLeft', delay: 100 }"
            >
              <div class="sub-title">{{ item.subTitle }}</div>
              <div class="content">{{ item.content }}</div>
              <div class="sub-list">
                <ul>
                  <li v-for="v in item.list" :key="v.id">
                    <div class="list-item">
                      <div class="item-title">{{ v.title }}</div>
                      <div class="item-desc">{{ v.desc }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="icon"
              v-scroll-animate="{ animation: 'bounceInRight', delay: 100 }"
            >
              <img :src="item.icon" alt="" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <ProductGet
      :width="1200"
      title="Digital Design Software Product Line"
      subTitle="Serving 1,000+ enterprise clients and 20,000+ designer users!"
      :bgImage="require('@/assets/images/digitalImg/product_bg.png')"
      :downLoadBtn="{
        label: 'Download Brochure',
        fileUrl: '',
        show: true,
      }"
      :contactBtn="{
        label: 'Let a Sales Representative Contact You',
      }"
    />
  </div>
</template>
<script>
import banner01 from "@/assets/images/digitalImg/banner_01.png";
import banner02 from "@/assets/images/digitalImg/banner_02.png";
import banner03 from "@/assets/images/digitalImg/banner_03.png";
import banner04 from "@/assets/images/digitalImg/banner_04.png";
import airoad_icon from "@/assets/images/digitalImg/airoad_icon.png";
import eicad_icon from "@/assets/images/digitalImg/eicad_icon.png";
import vrroad_icon from "@/assets/images/digitalImg/vrroad_icon.png";
import report3d_icon from "@/assets/images/digitalImg/report3d_icon.png";
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
export default {
  data() {
    return {
      lists: [
        {
          id: 1,
          title: "",
          icon: airoad_icon,
          subTitle: "Double the Bidding Efficiency, Halve the Solution Cost",
          bannerLink: "/digital/airoad",
          picUrl: banner01,
        },
        {
          id: 2,
          title: "",
          icon: eicad_icon,
          subTitle: "Extensive Professional Coverage, High Synergy Efficiency",
          bannerLink: "/digital/eicad",
          picUrl: banner02,
        },
        {
          id: 3,
          title: "",
          icon: vrroad_icon,
          subTitle: "Being Present in Road Design Schemes",
          bannerLink: "/digital/vrroad",
          picUrl: banner03,
        },
        {
          id: 4,
          title: "",
          icon: report3d_icon,
          subTitle: "Informed Decisions, Creativity First!",
          bannerLink: "/digital/report3d",
          picUrl: banner04,
        },
      ],
      content01: {
        title:
          "Digital Design Software Product Line – Leading the New Era of Smart Infrastructure",
        subTitle: "",
        content:
          "Delauney remains at the forefront of technology, integrating self-developed engines with AI to achieve exponential improvements in design efficiency.\n·  Versatile Functions – Comprehensive coverage across highways, municipal roads, and rail transit, delivering one-stop precision from alignment to traffic safety.\n·  Data Collaboration – Empowered by GIS and aerial surveying, ensuring seamless team collaboration.\n·  Dedicated Support – Backed by over 20 years of expertise, providing professional assistance throughout the entire process.",
        selectedIndex: 0,
        intervalId: null,
        productLines: [
          {
            softwareName: "AIRoad",
            title: "Double the Bidding Efficiency, Halve the Solution Cost",
            products: [],
            subTitles: [
              "Powered by a self-developed BIM engine, AIRoad enables rapid parametric and intelligent design. It improves solution design efficiency by 8–10 times and enhances overall design productivity by 20–30%.",
            ],
            image: require("@/assets/images/digitalImg/airoad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_airoad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/airoad_card.png"),
            link: "/digital/airoad", // 替换为实际链接
          },
          {
            softwareName: "EICAD",
            title: "Extensive Professional Coverage, High Synergy Efficiency",
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "EICAD supports highways, municipal roads, and rail transit, integrating multiple professional modules such as digital terrain modeling, alignment, interchanges, roadbed and pavement, bridges and culverts, tunnels, traffic engineering, and drainage systems.",
            ],
            image: require("@/assets/images/digitalImg/eicad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_eicad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/eicad_card.png"),
            link: "/digital/eicad", // 替换为实际链接
          },
          {
            softwareName: "VRRoad",
            title: "Being Present in Road Design Schemes",
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "VRRoad is a software-hardware integrated solution for road geometry design and safety evaluation. It supports multi-degree-of-freedom motion platforms, delivering a highly immersive driving experience.",
            ],
            image: require("@/assets/images/digitalImg/vrroad_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_vrroad_notext.png"),
            imageMask: require("@/assets/images/digitalImg/vrroad_card.png"),
            link: "/digital/vrroad", // 替换为实际链接
          },
          {
            softwareName: "Report3D",
            title: "Informed Decisions, Creativity First!",
            products: [], // 根据图片，这里没有列出具体产品，可留空或添加
            subTitles: [
              "Designed for multi-disciplinary engineering presentations, Report3D enables real-time rendering, efficient scene creation, and complex PPT production while allowing users to interact with digital twin models in real time.",
            ],
            image: require("@/assets/images/digitalImg/report3d_icon.png"),
            icon: require("@/assets/images/digitalImg/icon_report3d_notext.png"),
            imageMask: require("@/assets/images/digitalImg/report3d_card.png"),
            link: "/digital/report3d", // 替换为实际链接
          },
        ],
        // imgs: [
        //   { id: 1, img: airoad },
        //   { id: 2, img: eicad },
        //   { id: 3, img: vrroad },
        //   { id: 4, img: report3d },
        // ],
      },
      content02: {
        activeName: "1",
        title: "Unique Advantages Of Digital Design Software Product Line",
        content: [
          {
            id: "1",
            title: "Technical Advantages",
            subTitle: "Integration of AI Innovations",
            content:
              "AI-driven design processes, intelligent parameter settings, and automated solution generation accelerate your design efficiency like a rocket while unlocking endless creative inspiration.",
            list: [
              {
                id: 1,
                title: "AI-Powered Large Language Model",
              },
              {
                id: 2,
                title: "AIRilab AI Rendering",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon1.png"),
          },
          {
            id: "2",
            title: "Application Advantages",
            subTitle: "Integrated Design Matrix",
            content:
              'Deeply embedded and fully covering every stage, from outlining the strategic blueprint in the "Planning" phase, to building a detailed structure in the "Design" stage, ensuring strict quality control in the "Validation" process, all the way to the "Delivery" moment for final results presentation.',
            list: [
              {
                id: 1,
                title: "Scheme Comparison (AIRoad): ",
                desc: "Quickly generate multiple design alternatives, shortening planning cycles by 30%.",
              },
              {
                id: 2,
                title: "Scheme Design (EICAD): ",
                desc: "Automatically avoid conflicts and perform standard checks, reducing design change rates by 50%.",
              },
              {
                id: 3,
                title: "Driving Simulation Validation (VRRoad): ",
                desc: "Simulate driving perspectives to proactively identify potential issues such as insufficient sight distance and geometric flaws.",
              },
              {
                id: 4,
                title: "Scheme Reporting (Report 3D & Delivery 3D): ",
                desc: "Effortlessly create visual reports and standardized deliverables.",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon2.png"),
          },
          {
            id: "3",
            title: "Data Advantages",
            subTitle:
              'Seamless Data Flow, Breaking the "Multiple Software Switching" Dilemma',
            content:
              "From planning to delivery, one software matrix handles it all, improving team collaboration efficiency by 40%. Design outcomes are directly transferred to construction and operation & maintenance phases, maximizing infrastructure investment value. The digital deliverable provide an accurate data foundation for future smart maintenance.",
            list: [
              {
                id: 1,
                title: "Unified Data Foundation: ",
                desc: "All products are based on the same data architecture, ensuring data consistency across planning, design, validation, and delivery stages.",
              },
              {
                id: 2,
                title: "Automated Data Transfer:",
                desc: "Route plans from the planning phase are automatically transferred to the design phase without needing to redraw. BIM models from the design phase are directly used for validation and delivery, ensuring zero data loss.",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon3.png"),
          },
          {
            id: "4",
            title: "Service Advantages",
            subTitle: "Full-Cycle Professional Services",
            content:
              "We provide comprehensive professional services throughout the entire lifecycle of using digital design software, ensuring that users can seamlessly achieve their design goals.",
            list: [
              {
                id: 1,
                title: "7×24 Hour Technical Support：",
                desc: "No matter when or where, if users encounter technical challenges, our professional team will respond within 15 minutes. Through phone support, remote assistance, and other methods, we ensure timely resolution of any issues during the software usage process, ensuring uninterrupted design work.",
              },
            ],
            icon: require("@/assets/images/digitalImg/software_icon4.png"),
          },
        ],
      },
      content03: {
        title: "Digital Design Software Product Line",
        subTitle:
          "Serving 1,000+ enterprise clients and 20,000+ designer users!",
      },
    };
  },
  components: {
    VerticalBanner,
    ProductGet,
  },
  filters: {},
  computed: {},
  created() {
    this.startCarousel();
  },
  mounted() {},
  methods: {
    openUrl(link) {
      this.$uniFun.openInCurrentTab(link);
    },
    startCarousel() {
      this.content01.intervalId = setInterval(() => {
        this.content01.selectedIndex =
          (this.content01.selectedIndex + 1) %
          this.content01.productLines.length;
      }, 3000);
    },
    pauseCarousel(index) {
      clearInterval(this.content01.intervalId);
      this.content01.selectedIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.digtital-container {
  width: 100%;
  height: 100%;
  background: #fff;

  .banner {
    width: 100%;
    height: 640px;
    background: #fff;
    .processBox {
      color: #fff;
      position: absolute;
      top: 80px;
      left: 440px;
    }
  }
  .title {
    font-weight: bold;
    font-size: 28px;
    color: #333333;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    margin-bottom: 60px;
  }
  .content {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
  .content-01 {
    padding: 70px 0;
    width: 1200px;
    height: 928px;
    box-sizing: border-box;
    margin: 0 auto;
    .content {
      text-align: left;
      opacity: 0;
    }
    .content-banner {
      width: 100%;
      height: 400px;
      margin-top: 50px;
      opacity: 0;
      .product-lines {
        display: flex;
        justify-content: space-between;
        gap: 20px; /* 卡片之间的间距 */
        height: 400px;
        .product-card {
          position: relative;
          flex: 1; /* 每个卡片占据可用空间的三分之一 */
          min-width: 0; /* 防止flex item溢出 */
          height: 400px; /* 根据设计调整卡片高度 */
          border-radius: 8px;
          overflow: hidden; /* 确保放大的背景图不会超出卡片边界 */
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: flex 0.5s ease, box-shadow 0.3s ease; /* 为卡片本身添加轻微浮动效果 */
          .card-img {
            // width: 157px;
            height: 40px;
            display: none;
            transition: all 0.25s ease;
          }
          .softwareName {
            font-weight: bold;
            font-size: 32px;
            color: #ffffff;
            line-height: 32px;
            display: block;
          }
          .card-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: transform 0.4s ease-out; /* 图片放大动画效果 */
            z-index: 10;
          }
          .card-content {
            position: absolute;
            top: 20px;
            left: 20px;
            right: 20px;
            z-index: 20;
            color: #fff;
            .title {
              margin-bottom: 12px;
              line-height: 32px;
              font-size: 14px;
              transition: all 0.5s ease;
              color: #fff;
              text-align: left;
            }

            .products {
              margin-top: 70px;
              font-size: 14px;
              line-height: 24px;
              // text-align: justify;
              text-align: left;
              opacity: 0;
              transition: all 0.25s ease;
            }
          }
          .know-more-btn {
            position: absolute;
            left: 20px;
            bottom: 40px;
            padding: 8px 24px;
            background-color: transparent;
            color: white;
            border: 1px solid white;
            border-radius: 20px;
            cursor: pointer;
            font-size: 13px;
            align-self: flex-start; /* 按钮靠左 */
            transition: background-color 0.3s ease, color 0.3s ease,
              all 0.25s ease;
            z-index: 20;
            // opacity: 0;
            display: none;
            &:hover {
              background-color: white;
              color: #007bff; /* 或者卡片的主题色 */
            }
          }
          .card-icon-notext {
            position: absolute;
            left: 20px;
            bottom: 40px;
            z-index: 20;
            display: block;
          }
          &.selected {
            flex: 1.8;
            .card-content {
              .products {
                // display: block;
                opacity: 1;
              }
              .title {
                font-size: 24px;
              }
            }
            .know-more-btn {
              // opacity: 1;
              display: block;
            }
            .card-img {
              display: block;
            }
            .softwareName {
              display: none;
            }
            .card-icon-notext {
              display: none;
            }
          }
        }
      }
    }
  }
  .content-02 {
    width: 1200px;
    height: 686px;
    padding-top: 60px;
    box-sizing: border-box;
    margin: 0 auto;
    ::v-deep .el-tabs__item {
      color: #1d1d1f !important;
      font-size: 18px !important;
    }
    ::v-deep .el-tabs__item.is-active {
      color: #1d1d1f !important;
      font-weight: bold !important;
    }
    ::v-deep .el-tabs__item:hover {
      color: #1d1d1f !important;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2f69f2 !important;
      height: 3px;
    }
    .sub-main {
      position: relative;
      height: 450px;
      .icon {
        position: absolute;
        right: 0;
        bottom: 40px;
        width: 458px;
        height: 400px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .sub-box {
      width: 720px;
      margin-top: 30px;

      .sub-title {
        font-weight: 500;
        font-size: 20px;
        color: #1d1d1f;
        margin-bottom: 15px;
      }
      .content {
        font-weight: 400;
        font-size: 14px;
        color: #1d1d1f;
        line-height: 24px;
      }
      .sub-list {
        position: relative;
        width: 590px;
        margin-top: 24px;
        border-top: 1px solid rgba(29, 29, 31, 0.2);
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: -2px;
          width: 40px;
          height: 3px;
          background: #1d1d1f;
        }

        ul {
          li {
            margin-top: 24px;
            display: flex;
            &::before {
              content: "";
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #d8d8d8;
              margin: 5px 24px 0 0;
            }
            .list-item {
              flex: 1;
              .item-title {
                font-weight: bold;
                font-size: 16px;
                color: #1d1d1f;
              }
              .item-desc {
                margin-top: 6px;
                font-size: 14px;
                color: #1d1d1f;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }

  :deep(.el-tabs__item.is-active),
  :deep(.el-tabs__item:hover) {
    font-weight: 500;
    color: #1d1d1f;
  }
  :deep(.el-tabs__item) {
    font-size: 20px;
  }
  :deep(.el-tabs__active-bar) {
    background: #2f69f2;
  }
}
</style>
